








import Vue from "vue";
import { Tutor } from "../types";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    }
  },

  computed: {
    imageSource(): string {
      return (
        this.tutor.picture_url || require("../images/photo-placeholder.svg")
      );
    }
  }
});
